/**
 * Shopify Accessibility Remediation Layer
 * Scope: Screen readers + keyboard users
 * Platform: Shopify (non-invasive, JS-only)
 * WCAG target: Partial 2.1 AA risk reduction
 */

(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initA11yFixes);
  } else {
    initA11yFixes();
  }

  function initA11yFixes() {
    fixButtons();
    fixClickableDivs();
    fixVariantSelectors();
    fixImages();
    fixHeadings();
    fixLiveRegions();
    enhanceHulkAppsOptions();
  }

  /* -----------------------------------
   * 1. Buttons & Primary Actions
   * ----------------------------------- */
  function fixButtons() {
    const addToCart = document.querySelector(
      'button[type="submit"], .add-to-cart, [name="add"]'
    );

    if (addToCart && !addToCart.getAttribute("aria-label")) {
      addToCart.setAttribute(
        "aria-label",
        "Add custom engagement ring to cart"
      );
    }
  }

  /* -----------------------------------
   * 2. Clickable DIVs → Keyboard Accessible
   * ----------------------------------- */
  function fixClickableDivs() {
    const clickableDivs = document.querySelectorAll(
      'div[onclick], div[role="button"], .variant-option'
    );

    clickableDivs.forEach((el) => {
      if (!el.hasAttribute("tabindex")) {
        el.setAttribute("tabindex", "0");
      }

      if (!el.hasAttribute("role")) {
        el.setAttribute("role", "button");
      }

      el.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          el.click();
        }
      });
    });
  }

  /* -----------------------------------
   * 3. Variant / Option Selectors
   * ----------------------------------- */
  function fixVariantSelectors() {
    const optionGroups = document.querySelectorAll(
      '.product-form__input, fieldset'
    );

    optionGroups.forEach((group) => {
      const legend = group.querySelector("legend");
      if (legend && !group.hasAttribute("aria-labelledby")) {
        const id = "label-" + Math.random().toString(36).slice(2);
        legend.id = id;
        group.setAttribute("aria-labelledby", id);
      }
    });
  }

  /* -----------------------------------
   * 4. Product Images ALT Text
   * ----------------------------------- */
  function fixImages() {
    const images = document.querySelectorAll("img");

    images.forEach((img) => {
      if (!img.hasAttribute("alt") || img.getAttribute("alt").trim() === "") {
        img.setAttribute(
          "alt",
          "Custom engagement ring product image"
        );
      }
    });
  }

  /* -----------------------------------
   * 5. Headings (ARIA-only improvement)
   * ----------------------------------- */
  function fixHeadings() {
    const productTitle = document.querySelector(
      ".product__title, h1, [data-product-title]"
    );

    if (productTitle && productTitle.tagName !== "H1") {
      productTitle.setAttribute("role", "heading");
      productTitle.setAttribute("aria-level", "1");
    }
  }

  /* -----------------------------------
   * 6. Dynamic Price Announcements
   * ----------------------------------- */
  function fixLiveRegions() {
    const priceEl = document.querySelector(
      ".price, .product__price, [data-price]"
    );

    if (priceEl && !priceEl.hasAttribute("aria-live")) {
      priceEl.setAttribute("aria-live", "polite");
      priceEl.setAttribute("aria-atomic", "true");
    }
  }

  /* -----------------------------------
   * 7. Fix Hulk App Options
   * ----------------------------------- */
  function enhanceHulkAppsOptions(root = document) {
  const options = root.querySelectorAll(
    '[data-parent="hulkapps_product_options"]'
  );

  options.forEach((el) => {
    // Avoid double-processing
    if (el.dataset.a11yEnhanced === 'true') return;

    el.dataset.a11yEnhanced = 'true';

    // Make focusable
    el.setAttribute('tabindex', '0');

    // Button semantics
    el.setAttribute('role', 'button');

    // Accessible name
    const label =
      el.getAttribute('value') ||
      el.getAttribute('data-conditional-value') ||
      el.textContent.trim();

    if (label) {
      el.setAttribute('aria-label', label);
    }

    // Keyboard interaction
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        el.click();
      }
    });
  });
}


const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;

      // If the node itself is an option
      if (node.matches?.('[data-parent="hulkapps_product_options"]')) {
        enhanceHulkAppsOptions(node.parentNode);
      }

      // Or contains options
      if (node.querySelectorAll) {
        enhanceHulkAppsOptions(node);
      }
    });
  });
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

})();